import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/views/StatusPage.tsx");
